export default __webpack_public_path__ + "static/media/Yun's Cold Flame.0863a4a8.jpg";